import { HealthTeam } from "@/@types/esus/HealthTeam";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorC4ByHealthTeamParams = Partial<PaginationFilter> & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export class ResumeIndicatorC4ByHealthTeamData {
	healthTeam?: HealthTeam;
	totalDiabeticCitizensInPeriod: number = 0;
	totalDiabeticCitizensInPeriodScore: number = 0;
	maxDiabeticCitizensInPeriodScore: number = 0;
}

export async function getResumeIndicatorC4ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorC4ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorC4ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c4/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorC4ByHealthTeamData>();
}
